// A short two-tone "ding" synthesized via the Web Audio API - no audio
// asset file needed (there's no existing notification sound anywhere in
// this app to reuse, and shipping a binary just for this felt heavier than
// a few lines of oscillator code). One shared AudioContext, created lazily
// on first use since browsers refuse to start one before any user gesture
// has happened on the page - by the time a WS notification fires, the
// teacher has long since interacted with the page, so this is safe.
let sharedContext = null;

function getContext() {
   if (!sharedContext) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      sharedContext = new Ctx();
   }
   return sharedContext;
}

function tone(ctx, frequency, startAt, duration) {
   const oscillator = ctx.createOscillator();
   const gain = ctx.createGain();
   oscillator.type = 'sine';
   oscillator.frequency.value = frequency;
   gain.gain.setValueAtTime(0, startAt);
   gain.gain.linearRampToValueAtTime(0.18, startAt + 0.02);
   gain.gain.linearRampToValueAtTime(0, startAt + duration);
   oscillator.connect(gain);
   gain.connect(ctx.destination);
   oscillator.start(startAt);
   oscillator.stop(startAt + duration);
}

export function playNotifySound() {
   const ctx = getContext();
   if (!ctx) return;
   if (ctx.state === 'suspended') ctx.resume().catch(() => {});
   const now = ctx.currentTime;
   tone(ctx, 740, now, 0.14);
   tone(ctx, 988, now + 0.13, 0.18);
}

// A lower, single descending tone - deliberately the inverse shape of the
// two-tone "ding" above, so a task failure is distinguishable by ear alone
// (e.g. with the tab backgrounded/unwatched) without needing to look.
export function playErrorSound() {
   const ctx = getContext();
   if (!ctx) return;
   if (ctx.state === 'suspended') ctx.resume().catch(() => {});
   const now = ctx.currentTime;
   tone(ctx, 330, now, 0.22);
}
